import { SidePanel } from '@/components/SidePanel/SidePanel';
import { ConfirmEmailForm } from './components/confirm-email-form';
import IntlMessages from '@/components/utility/intlMessages';
import { useParams } from 'react-router';

function EmailConfirmation() {
  const { email } = useParams();

  return (
    <div className="grid flex-1 grid-cols-1 md:grid-cols-[35%_1fr]">
      <div className="flex flex-col gap-y-5 m-6 md:m-10 py-10">
        <h3 className="text-xl">
          <IntlMessages id="page.confirmEmailTitle" />
        </h3>
        <p>
          <IntlMessages id="page.confirmEmailParagraph" />
        </p>
        <p className="font-bold">{email}</p>
        <ConfirmEmailForm email={email} />
      </div>
      <div className="md:shadow-[inset_rgba(0,0,0,0.05)_0px_4px_10px_0px] overflow-y-auto h-full">
        <SidePanel />
      </div>
    </div>
  );
}

export default EmailConfirmation;
